import environment from '@/environments/environment.dev'

import HttpClient from '../apiHttpClient'

const PROMOTION_ENDPOINT = '/v1.0/product/promotion'

const adminFapiClient = new HttpClient(environment.adminFAPIUrl)

interface PromotionItem {
  currencyUnit: string
  listPrice: number
  materialName: string
  materialNumber: string
  pictureUrl: string
}

const getProductInfo = async (materialNumber: string) => {
  return adminFapiClient.get(`/v1.0/product/${materialNumber}`)
}

const getPromotionList = async () => {
  return adminFapiClient.get(PROMOTION_ENDPOINT)
}

const updatePromotionList = async (list: PromotionItem[]) => {
  return adminFapiClient.post(PROMOTION_ENDPOINT, {
    body: list,
  })
}

export const adminFapiPromotion = {
  getProductInfo,
  getPromotionList,
  updatePromotionList,
}
